
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'


import { Core } from '../core/core'
import { SE_POSITIONING_SERVICE_MODULE_BUNDLE } from '../positioning-service/positioning-service.module'
import { SePopoverComponent } from './popover.component'
import { SeIconModule } from '../icon/icon.module'

@NgModule({
  declarations: [
    SePopoverComponent
  ],
  imports: [
	CommonModule, 
    SeIconModule
  ],
  exports: [
    SePopoverComponent
  ]
})
export class SePopoverModule {}

export const SE_POPOVER_MODULE_BUNDLE = `${Core.ANGULAR_MODULE}.popover`

